export default __webpack_public_path__ + "static/media/hamburger.e1986d7e.svg";